export default __webpack_public_path__ + "static/media/838.ceb43c93.png";